import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AgendasService } from '../Agendas/agendas.service';
import { Notification_Service } from '../Notifications/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  currentURL='';
  options:any;
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly META_DATA = 'META_DATA';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';

  _selectedUser: BehaviorSubject<any>;
  _userToUpdate: any;
  _emailToUpdate: any;
  emails={email1:"",email2:"",}
  taxYear='';
  serviceEnvironment='';
  dataStore:{selectedUser:InternalUserModel, reponseData:any}
  private http: HttpClient;

  constructor(private router: Router,private httpBackend: HttpBackend, private notificationService: Notification_Service) {
    this.http = new HttpClient(httpBackend);
    this.currentURL = window.location.origin.includes('localhost')? "": environment.BaseURL;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'});
      this.options = { headers: headers };


    this._selectedUser = <BehaviorSubject<any>>new BehaviorSubject('');
    this.dataStore ={selectedUser:null, reponseData:null};
    
  }


  get selectedUser(){
    return this._selectedUser.asObservable()
  }

  isAuthenticated(){
    // call Api endpoint to get Selected user with the currente bearrer, 
    //and set Selected User, that will triger the get all agendas.
    let tokens =this.getJwtToken()
    return  tokens !== null;
  }

  getUserName(){
    return this.dataStore?.selectedUser?._agentName ;
  }
  getAgentId(){
    return this.dataStore?.selectedUser._agentId ;
  }
  getAgentSecundaryEmail(){
    return this.dataStore?.selectedUser._emailTwo ;
  }

  getEmails(){
    return this.emails;
  }

  getTaxYear(){
    return this.taxYear;
  }

  getServiceEnvironment(){
    return this.serviceEnvironment;
  }

  setTaxYearSystemSetting(taxYear:string){
    this.taxYear =taxYear
  }

  setServiceEnvironment(env:string){
    this.serviceEnvironment =env;
  }

  isAccountActive(schemaIdGuid:string) {
    return this.http.get<any>( this.currentURL + environment.isAccountActive +schemaIdGuid, this.options)
  }

  setLoggedInUser(data:any){
    this.emails.email1 =data.agentEmail
    this.emails.email2 =data.agentEmail2
    let user:InternalUserModel = {
        _agentName:data.agentName,
        _username:data.userName,
        _agentId:data.agentCode,
        _agentGuid:data.schemaIdGuid,
        _email:data.agentEmail,
        _phone:data.tel,
        _emailTwo:data.agentEmail2,
        _AgentAddress1:data.agentAddress1,
        _AgentAddress2:data.agentAddress2,
        _AgentAddress3 :data.agentAddress3,
        _AgentAddress4 :data.agentAddress4,
        _AgentAddress5 :data.agentAddress5,//to save the address look at how the string is put toguether
        _phone2:data.tel2,
        _fax:data.fax,
        _business:data.business,
        _contact:data.contact,
        _password:'',
        _confPassword:''
      };
    this.dataStore.selectedUser =  user;
    this.dataStore.reponseData =  data;
    this._selectedUser.next(Object.assign({}, this.dataStore).selectedUser)
  }

  checkUserNameAvailability(username:string){
    //make request to server side
    return this.http.post<any>(this.currentURL + environment.checkUserNameAvailability,
    {Username:username,Password:''},
    { headers: new HttpHeaders({'Content-Type': 'application/json'})})
  }

  isAppOffline(){
    this.http.post<any>(this.currentURL + environment.isAppOffline, {},this.options).subscribe((x:any) => {
      if(!x.taxYear || !x.env){
        this.notificationService.errorNotif('Error with respnse at isAppOffline. Missing : ' + (!x.taxYear?'taxYear':'') 
        + (!x.taxYear&&!x.env ?', ':'') +  (!x.env ?'environment':'') + '. Please contact our office at (305) 375-4109.');
      }
      this.setTaxYearSystemSetting(x.taxYear);
      this.setServiceEnvironment(x.env)
      if (x.url !=='') { 
        document.location.href = x.url;
      } 
    },
    err=>{
      this.notificationService.errorNotif('Error Thrown (at isAppOffline). Please contact our office at (305) 375-4109 and notify about this error.');
    });
  }

  authenticate(gui:string){
    this.http.get<any>(this.currentURL + environment.GetUserByGuid +gui, this.options).subscribe((data:any) => {
      if(data){
        if(this.dataStore.selectedUser?._agentId !== data.agentCode){ 
          this.setLoggedInUser(data)
        }
      }
      else{
        this.notificationService.errorNotif("Unable to Authenticate user. Error at the time of collecting User Data.");
        this.dataStore ={selectedUser:null, reponseData:null};
        this._selectedUser.next(Object.assign({}, {}))
        this.removeTokens();
      }
    },
    error =>{
      this.notificationService.errorNotif("Unable to Authenticate user");
    this.doLogoutUser(false)
      let a=error;
    }); 
  }

  ValidateRecoveryGuid(gui:string){
    let err:any={};
    this.http.get<any>(this.currentURL + environment.ValidateRecoveryGuid +gui, this.options).subscribe((data:any) => {
      if(data)
          this._userToUpdate = data;
    },
    error =>{
      err=error;
      this._userToUpdate=null;
      if(!this._userToUpdate && error.error.includes('User Account Not Active.')){
        this.notificationService.errorNotif("User Account Not Active. Ask your system admin to send a link To register the account.");
      }
      else{
        this.notificationService.errorNotif(error.error);
      }
    },
    () =>{
      if(!this._userToUpdate){
        this.notificationService.errorNotif("The Validation Link you are attempting to use expired, please provide required details to recover your password.");
      }
    }); 
  }

  ValidateEmailRecoveryGuid(gui:string){
    let err:any={};
    this.http.get<any>(this.currentURL + environment.ValidateEmailRecoveryGuid +gui, this.options).subscribe((data:any) => {
      if(data)
          this._emailToUpdate = data;
    },
    error =>{
      err=error;
      this._emailToUpdate=null;
      if( error.error.includes('User Account Not Active.')){
        this.notificationService.errorNotif("User Account Not Active. Ask your system admin to send a link To register the account.");
      }
      else{
        this.notificationService.errorNotif(error.error);
      }
    },
    () =>{
      if(!this._emailToUpdate){
        this.notificationService.errorNotif("The Validation Link you are attempting to use expired.");
      }
    }); 
  }

  doLogoutUser( navigateToSignIn:boolean) {
    this.dataStore ={selectedUser:null, reponseData:null};
    this._selectedUser.next(Object.assign({}, {}))
    this.removeTokens();
    if(navigateToSignIn)this.router.navigateByUrl('/sign-in');
  }

  signIn(name:string, pass:string){
          this.removeTokens()
          this.http.post<any>(this.currentURL + environment.authenticate,
          {Username:name,Password:pass},
          { headers: new HttpHeaders({'Content-Type': 'application/json'})}).subscribe((data:any) => {
            this.removeTokens()
            if(data)this.storeTokens(data);
            this.selectedUser.subscribe(x=>
              {
              let token =this.getJwtToken();
              if(x != '' && token){
                this.router.navigateByUrl('/registered-agent');
              }
            });
        },
        error =>{
          console.log(error);
          let a= error;
          this.notificationService.errorNotif("Login Attempt Failed. Please enter your credentials.");
        });
  }

  UpdateContact(iuser:InternalUserModel ) {
    this.dataStore.reponseData
    let updatedModel={
      // UserId:this.dataStore.reponseData.userId,
      SchemaIdGuid:this.dataStore.reponseData.schemaIdGuid,
      UserName: this.dataStore.reponseData.userName,
      Password :this.dataStore.reponseData.password,
      Status: this.dataStore.reponseData.status,
      AgentInfoId:this.dataStore.reponseData.agentInfoId,
      AgentName:iuser._agentName,
      AgentCode:this.dataStore.reponseData.agentCode,
      TaxYear:this.dataStore.reponseData.taxYear,
      AgentAddress1:iuser._business,
      AgentAddress2:iuser._AgentAddress2,
      AgentAddress3:iuser._AgentAddress3, //_AgentAddress3_AgentAddress4 +_AgentAddress5 sum of all three addresses
      AgentAddress4:iuser._AgentAddress4,
      AgentAddress5:iuser._AgentAddress5,
      Tel:iuser._phone,
      Tel2:iuser._phone2,
      Fax :iuser._fax,
      Business:iuser._business,
      Contact:iuser._contact,
      AgentReplacementEmail1: iuser._email,
      AgentReplacementEmail2: iuser._emailTwo,
    }
    return this.http.post<any>(this.currentURL + environment.UpdateAgentsInfo , updatedModel, this.options)
  }

  UpdatePassword(_password:string){
    return this.http.post<any>(this.currentURL + environment.UpdateAgentsPassword , {password: _password, schemaIdGuid:this._userToUpdate.schemaIdGuid}, this.options)
  }

  createAccount(iuser:InternalUserModel){
        let updatedModel:ResponseAccountUser={
      // UserId:this.dataStore.reponseData.userId,
      SchemaIdGuid:this.dataStore.reponseData.schemaIdGuid,
      UserName: iuser._username,
      Password :iuser._password,
      Status: 'Active',
      AgentInfoId:this.dataStore.reponseData.agentInfoId,
      AgentName:iuser._agentName,
      AgentEmail:iuser._email,
      AgentCode:this.dataStore.reponseData.AgentCode,
      TaxYear:this.dataStore.reponseData.TaxYear,
      AgentAddress1:iuser._AgentAddress1,
      AgentAddress2:iuser._AgentAddress2,
      AgentAddress3:iuser._AgentAddress3, //_AgentAddress3_AgentAddress4 +_AgentAddress5 sum of all three addresses
      AgentAddress4:iuser._AgentAddress3,
      AgentAddress5:iuser._AgentAddress3,
      Tel:iuser._phone,
      Tel2:iuser._phone2,
      Fax :iuser._fax,
      Business:iuser._business,
      Contact:iuser._contact,
      AgentEmail2:iuser._emailTwo,
    }
    return this.http.post<any>(this.currentURL + environment.UpdateUser , updatedModel, this.options)
  }


  sendRecoveryEmail(iuser:InternalUserModel){
    return  this.http.post<any>(this.currentURL + environment.emailPasswordRecovery , {Email:iuser._email, AgentCode:iuser._agentId}, this.options)
  }

  confirmEmailUpdate(emailToUpdate:{originalEmail:string,  replacementEmail:string, agentCode :number, emailIndex:string}){
    return  this.http.post<any>(this.currentURL + environment.confirmEmailUpdate , emailToUpdate, this.options)
  }

  storeTokens(tokens: Tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.token);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refreshToken);

    let agent =JSON.stringify(tokens.agent)
    localStorage.setItem(this.META_DATA, agent);
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.META_DATA);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }

  refreshToken() {
    return this.http.post<any>(this.currentURL + environment.Refresh, { 
      'refreshToken': this.getRefreshToken(), 'jwtToken' : this.getJwtToken(), 'userName' : this.dataStore.selectedUser._username
    }).pipe(tap((tokens: Tokens) => {
      this.storeJwtToken(tokens.token, tokens.refreshToken , JSON.stringify(tokens.agent));
    }));
  }
  private storeJwtToken(jwt: string, refJWT: string, agent:string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);
    localStorage.setItem(this.META_DATA, agent);
    localStorage.setItem(this.REFRESH_TOKEN, refJWT);
  }

  getJwtToken() {
    let token =localStorage.getItem(this.JWT_TOKEN);
    let agent = localStorage.getItem(this.META_DATA)
    let AgentObj = JSON.parse(agent)
    if( AgentObj && (!this.dataStore.selectedUser || this.dataStore.selectedUser._agentId != AgentObj.agentCode )){
      if(AgentObj ){//&& this.router.url.includes("registered-agent")){
        this.setLoggedInUser(AgentObj);
      }
    }
    return token
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }
}



export interface InternalUserModel {
  _agentName:string
  _username:string
  _agentId:string
  _agentGuid:string
  _email:string
  _emailTwo:string
  _AgentAddress1:string
  _AgentAddress2:string
  _AgentAddress3:string
  _AgentAddress4:string
  _AgentAddress5:string
  _phone:string
  _phone2:string
  _fax:string
  _business:string
  _contact:string
  _password:string
  _confPassword:string
} 
export interface ResponseAccountUser {
  // UserId:string,
  SchemaIdGuid:string,
  UserName:string,
  Password :string,
  Status:string,
  AgentInfoId:string,

  AgentName:string,
  AgentEmail:string,
  AgentCode:string,
  TaxYear:string,
  AgentAddress1:string,
  AgentAddress2:string,
  AgentAddress3:string,
  AgentAddress4:string,
  AgentAddress5:string,
  Tel:string,
  Tel2:string,
  Fax :string,
  Business:string,
  Contact:string,
  AgentEmail2:string,
}

export interface Tokens{
  token :string,
  refreshToken:string,
  SchemaIdGuid :string,
  agent :any
}
